module.exports = __webpack_public_path__ + "img/pageinteriors_profesionales-independientes-y-pymes-01autos.be9776c1.jpg";